<div class="create-course">

  <h3>Create New Course</h3>

  <form>

    <mat-form-field appearance="outline">

      <input placeholder="Course title" matInput>

    </mat-form-field>

    <div class="course-image-upload">

      <span>Course thumbnail:</span>

      <img class="course-thumbnail mat-elevation-z3">

    </div>

    <mat-form-field appearance="outline">

      <mat-select placeholder="Select category">
        <mat-option value="BEGINNER">Beginner</mat-option>
        <mat-option value="INTERMEDIATE">Intermediate</mat-option>
        <mat-option value="ADVANCED">Advanced</mat-option>
      </mat-select>

    </mat-form-field>

    <mat-form-field appearance="outline">

      <input placeholder="Course url" matInput>

    </mat-form-field>

    <mat-form-field appearance="outline">

      <textarea matInput placeholder="Course description"></textarea>

    </mat-form-field>

    <mat-slide-toggle class="promo" color="primary">
      Course in promotion?
    </mat-slide-toggle>

    <mat-form-field appearance="outline">
      <mat-label>Promotion start date</mat-label>
      <input matInput [matDatepicker]="promoStartPicker">
      <mat-datepicker-toggle matSuffix [for]="promoStartPicker"></mat-datepicker-toggle>
      <mat-datepicker #promoStartPicker></mat-datepicker>
    </mat-form-field>

    <button mat-raised-button color="warn">
      Create Course
    </button>

  </form>

</div>


